export const ADMIN_USER_GROUP_MANAGEMENT_PREFIX =
  'ADMIN-USER-GROUP-MANAGEMENT-PREFIX_';

export const FETCH_GROUP_LIST =
  ADMIN_USER_GROUP_MANAGEMENT_PREFIX + 'FETCH_GROUP_LIST';

export const SEARCH_REFRESH =
  ADMIN_USER_GROUP_MANAGEMENT_PREFIX + 'SEARCH_REFRESH';
